import React from "react";
import { Module } from "../../components";
import { HomePage } from "./pages";

const Capitalizacao = () => {
  return (
    <Module
      moduleName="Capitalização"
      description="Uma página para você, cliente, saber mais sobre seu título, sorteios e outras dúvidas."
    >
      <Module.Page path="/" page={HomePage} title="Página Inicial" />
    </Module>
  );
};

Capitalizacao.propTypes = {};

export default Capitalizacao;
